<template>
  <div class="question">
    <div class="container" v-if="questionData">
      <QuestionSteps
        class="steps-ponent"
        :index="questionData.questionIndex"
        :total="questionData.question.length"
        @pre="bindPreQuestion"
        :theme="questionData.theme"
      />
      <div class="question-content">
        <div class="que-scroll" ref="questionScroll">
          <QuestionItem
            v-if="
              questionData.question &&
              questionData.question.length &&
              questionData.question[questionData.questionIndex]
            "
            :data="questionData.question[questionData.questionIndex]"
            @change="bindChange"
            :theme="questionData.theme"
          />
        </div>
        <div class="btn-content">
          <div
            class="next-step"
            :style="{ background: questionData.theme.btnColor }"
            v-show="showNext"
            @click="bindNextQuestion"
            >下一题</div
          >
          <div
            class="confirm"
            v-show="questionData.finished"
            @click="bindConfirm"
            :style="{ background: questionData.theme.btnColor }"
            >完成</div
          >
        </div>
        <div class="tips" v-if="questionData.que_attr != 1"
          ><span class="red">*</span
          >测试结果由每个选项综合计算得出，请务必准确填写</div
        >
      </div>
    </div>
    <AppLoading class="loading" v-if="!loaded" />
  </div>
</template>
<script>
import { Question } from './question.js'
import QuestionSteps from './components/steps.vue'
import QuestionItem from './components/question-item.vue'
import AppLoading from '@/components/app/loading/loading'
import Bus from '@/utils/bus' // 引入事件总线
export default {
  components: {
    QuestionSteps,
    QuestionItem,
    AppLoading
  },
  data() {
    return {
      loaded: false,
      questionData: null
    }
  },
  computed: {
    /* 是否显示下一题 问卷能下一题时并且题目类型不是单选 */
    showNext() {
      let cur = this.questionData.question[this.questionData.questionIndex]
      if (cur.que_type == 0) {
        for (let i = 0; i < cur.options.length; i++) {
          let item = cur.options[i]
          if (cur.value === item.key) {
            if (item.que_answer_attr) {
              return true
            } else {
              return false
            }
          }
        }
      } else {
        return this.questionData.canNext
      }
    },
    showFinished() {
      return true
    }
  },
  created() {
    this.getQuestionData()
    this.setTitle()
    this.$http.addDataLog({
      eventk: 'SHOW_common_questions_1',
      eventv: this.$route.query.id
    })
  },
  mounted() {
    Bus.$on('commonQuestionRadioSelectOther', this.scrollToBottom)
  },
  beforeDestroy() {
    Bus.$off('commonQuestionRadioSelectOther', this.scrollToBottom)
  },
  methods: {
    scrollToBottom() {
      let scrollBox = this.$refs.questionScroll
      if (scrollBox) {
        scrollBox.scrollTo({
          top: scrollBox.scrollHeight - scrollBox.clientHeight,
          left: 0,
          behavior: 'smooth'
        })
      }
    },
    setTitle() {
      this.$betterwe.initWebViewUIConfig({
        title: this.$route.query.title || '问卷',
        isTransparentBottomBar: 1
      })
      document.title = this.$route.query.title || '问卷'
    },
    bindChange(value) {
      this.questionData.change()
    },
    bindPreQuestion() {
      this.questionData.pre()
    },
    /* 下一题 */
    bindNextQuestion() {
      this.questionData.next()
    },
    //隐藏题目
    hideQuestion() {},
    //显示题目
    showQuestin() {},
    bindConfirm() {
      if (this.questionData.que_allow_num == 1) {
        this.$dialog
          .confirm({
            title: '提示',
            message: '问卷结果一旦确认就无法修改，您是否已确认所有选项所填无误'
          })
          .then(() => {
            this.bindSubmit()
          })
          .catch(() => {
            // on cancel
          })
      } else {
        this.bindSubmit()
      }
    },
    bindSubmit() {
      let res = this.questionData.getResult()
      let params = {
        que_id: this.questionData.id,
        info: res
      }
      this.$http
        .postBaseAppWithHeader('que/QueBase/saveQue', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$router.replace({
              path: '/common-questions/result/q' + this.questionData.id,
              query: {
                que_id: res.data,
                que_type: this.questionData.id,
                que_title: this.questionData.que_title,
                que_explain: this.questionData.que_explain,
                que_cover: this.questionData.que_cover,
                sfrom: this.$route.query.sfrom
              }
            })
          } else {
            this.$toast(res.msg)
          }
        })
    },
    getQuestionData() {
      let params = {
        id: this.$route.query.id,
        type: 2
      }
      this.$http
        .getBaseApp('que/QueBase/initQue', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.questionData = new Question(res.data)
          } else {
            this.$toast(res.msg)
          }
        })
        .finally(() => {
          this.loaded = true
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.question {
  background-color: rgba(247, 247, 247, 1);
  height: 100vh;
}

.loading {
  position: fixed;
  left: 50%;
  top: 30%;
  transform: translate(-50%, -50%);
}

.container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 16px 16px 45px;
  box-sizing: border-box;

  .steps-ponent {
    margin-bottom: 16px;
  }

  .question-content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    background: #ffffff;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 26px;
    box-sizing: border-box;

    .que-scroll {
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow-y: scroll;
      position: relative;
    }

    .btn-content {
      margin-top: 16px;
      height: 50px;
      overflow: hidden;
    }

    .next-step,
    .confirm {
      text-align: center;
      width: 188px;
      height: 50px;
      background: #524485;
      border-radius: 25px;
      font-size: 20px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      color: #ffffff;
      line-height: 50px;
    }

    .tips {
      margin-top: 12px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(39, 36, 60, 0.5);
      line-height: 20px;

      .red {
        margin-right: 4px;
        color: rgba(255, 85, 119, 1);
      }
    }
  }
}
</style>
